import { motion } from "framer-motion";
import { ShieldCheck, Lock, Zap } from "lucide-react";
import { Reveal, SectionTitle } from "./motion";

export const Guarantee = () => (
  <section className="bg-paper py-20 sm:py-28" data-testid="guarantee-section">
    <div className="mx-auto grid max-w-5xl items-center gap-10 px-5 md:grid-cols-[auto_1fr]">
      <Reveal>
        <motion.div animate={{ rotate: 360 }} transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          className="relative mx-auto flex h-44 w-44 items-center justify-center rounded-full bg-mint text-white sm:h-52 sm:w-52">
          <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full">
            <defs><path id="circ" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" /></defs>
            <text fontSize="15" fontWeight="700" letterSpacing="4" fill="#fff"><textPath href="#circ">GARANTIA INCONDICIONAL • 7 DIAS • RISCO ZERO •</textPath></text>
          </svg>
          <ShieldCheck className="h-14 w-14" strokeWidth={1.6} />
        </motion.div>
      </Reveal>
      <Reveal delay={0.1}>
        <SectionTitle className="text-ink">Garantia incondicional de <span className="text-mint">7 dias</span></SectionTitle>
        <p className="mt-4 max-w-xl text-base text-ink/75 sm:text-lg">Acesse, veja o acervo e a licença. Se não for para você, <b className="text-ink">devolvemos seu dinheiro sem perguntas.</b></p>
        <div className="mt-6 flex flex-wrap gap-2 text-sm font-semibold text-ink">
          {[[Lock, "Pagamento seguro"], [ShieldCheck, "Privacidade protegida"], [Zap, "Acesso imediato"]].map(([I, t]) => (
            <span key={t} className="flex items-center gap-2 rounded-full bg-mint/10 px-4 py-2"><I className="h-4 w-4 text-mint" />{t}</span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export const Testimonials = () => (
  <section className="bg-ink py-20 text-white sm:py-28" data-testid="testimonials-section">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal>
        <SectionTitle className="max-w-3xl">Veja o que dizem sobre <span className="text-sun">nossos materiais!</span></SectionTitle>
      </Reveal>
      <Reveal delay={0.1}>
        <figure className="mt-12 overflow-hidden rounded-[32px] bg-white/5 p-2 ring-1 ring-white/10 sm:p-3">
          <img src="/img/depoimentos.webp" alt="Mensagens de clientes contando suas primeiras vendas com os kits" loading="lazy" width={1536} height={1024}
            className="h-auto w-full rounded-[26px]" data-testid="testimonials-image" />
        </figure>
      </Reveal>
    </div>
  </section>
);
